import cn from 'clsx'
import { FC, ReactNode } from 'react'

import { Typography } from '@/components/ui'

import { IHistoryTableRowData } from '@/types/history.interface'

interface IHistoryCellProps {
	children: ReactNode
	className?: string
}

const rowCellBaseClass =
	'flex items-center w-[12.5%] min-w-[100px] text-gray-600 min-w-0 pl-3'
const textBaseClass = 'whitespace-normal break-all'
const downloadLinkClassName =
	'rounded-[32px] z-10 flex w-fit items-center justify-center bg-gray-600 p-2.5 text-white transition-opacity duration-200 hover:bg-gray-500'

const RowCell: FC<IHistoryCellProps> = ({ className, children }) => {
	return (
		<div className={cn(rowCellBaseClass, className)}>
			<Typography variant='text' className={textBaseClass}>
				{children}
			</Typography>
		</div>
	)
}

interface IHistoryTableRowProps {
	row: IHistoryTableRowData
}

const HistoryTableRow: FC<IHistoryTableRowProps> = ({ row }) => {
	return (
		<div className='flex min-h-14 border-b border-gray-300 py-[5px] pr-3 transition-colors hover:bg-gray-100'>
			<RowCell className='!w-[15%]'>{row.id}</RowCell>
			<RowCell className='!w-[7.5%]'>{row.listener}</RowCell>
			<RowCell>{row.userName}</RowCell>
			<RowCell>{row.startedAt}</RowCell>
			<RowCell>{row.finishedAt}</RowCell>
			<RowCell>{row.runtime}</RowCell>
			<RowCell className='!w-[7.5%]'>{row.status}</RowCell>

			<div className='flex w-[20%] min-w-[100px] flex-wrap items-center gap-2 pl-3'>
				{row.downloads.length > 0 ? (
					row.downloads.map(download => (
						<a
							key={`${row.key}-${download.type}`}
							href={download.href}
							download={download.filename}
							className={downloadLinkClassName}
						>
							<Typography variant='text'>{download.label}</Typography>
						</a>
					))
				) : row.errorMessage ? (
					<Typography variant='text'>{row.errorMessage}</Typography>
				) : row.status === 'STARTED' ? (
					<Typography variant='text'>No information yet</Typography>
				) : (
					<Typography variant='text'>-</Typography>
				)}
			</div>
		</div>
	)
}

export default HistoryTableRow
